(function() {
  async function fetchLeaders({ season, count }) {
    // 1) Fetch top points leaders from NHL stats REST (CORS OK)
    const seasonId = new Date();
    const y = seasonId.getUTCFullYear();
    const m = seasonId.getUTCMonth() + 1;
    const startY = m >= 9 ? y : y - 1;
    const seasonStr = `${startY}${startY + 1}`; // e.g., 20252026
    const leadersUrl = `https://api.nhle.com/stats/rest/en/skater/summary?limit=${count}&dir=DESC&sort=points&cayenneExp=seasonId=${seasonStr}`;
    const proxies = [
      'https://corsproxy.io/?',
      'https://cors.isomorphic-git.org/'
    ];

    async function tryJson(urlToFetch) {
      try {
        const r = await fetch(urlToFetch, { mode: 'cors', cache: 'no-cache' });
        if (!r.ok) return null;
        return await r.json();
      } catch (_) {
        return null;
      }
    }

    let leadersJson = await tryJson(leadersUrl);
    if (!leadersJson) {
      // Try proxy fallback for CORS
      for (let i = 0; i < proxies.length && !leadersJson; i += 1) {
        const proxyUrl = proxies[i] + encodeURI(leadersUrl);
        leadersJson = await tryJson(proxyUrl);
      }
    }
    if (!leadersJson) throw new Error('Failed to fetch leaders');
    const items = leadersJson.data || leadersJson.rows || [];

    // 2) For each player, fetch player landing for headshot/team logo
    async function fetchPlayerDetails(id) {
      const base = `https://api-web.nhle.com/v1/player/${id}/landing`;
      let details = await tryJson(base);
      if (!details) {
        for (let i = 0; i < proxies.length && !details; i += 1) {
          const proxyUrl = proxies[i] + encodeURI(base);
          details = await tryJson(proxyUrl);
        }
      }
      return details || {};
    }

    const results = [];
    for (let i = 0; i < Math.min(items.length, count); i += 1) {
      const it = items[i];
      const details = await fetchPlayerDetails(it.playerId);
      console.log('each item', it);
      results.push({
        id: it.playerId,
        firstName: (details.firstName && details.firstName.default) || (it.skaterFullName ? it.skaterFullName.split(' ')[0] : ''),
        lastName: (details.lastName && details.lastName.default) || (it.skaterFullName ? it.skaterFullName.split(' ').slice(1).join(' ') : ''),
        headshot: details.headshot || '',
        teamAbbrev: details.currentTeamAbbrev || it.teamAbbrevs || '',
        teamLogo: details.teamLogo || (details.currentTeamAbbrev ? `https://assets.nhle.com/logos/nhl/svg/${details.currentTeamAbbrev}_light.svg` : ''),
        position: details.position || it.positionCode || '',
        games: it.gamesPlayed || 0,
        goals: it.goals || 0,
        assists: it.assists || 0,
        points: it.points || 0,
        plusMinus: it.plusMinus || 0,
      });
    }
    const top = results;

    try {
      localStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: top }));
    } catch (_) {}

    return top;
  }

  function renderTable(table, leaders) {
    const tbody = table.querySelector('tbody');
    tbody.innerHTML = '';
    leaders.forEach((p, idx) => {
      const tr = document.createElement('tr');
      const nameHtml = `
        <div class="nhl-name-cell">
          <div class="nhl-name-left">
            <span class="nhl-headshot">${p.headshot ? `<img src="${p.headshot}" alt=""/>` : ''}</span>
            <span class="nhl-player-name">${p.firstName || ''} ${p.lastName || ''}</span>
          </div>
          <span class="nhl-team">${p.teamLogo ? `<span class="nhl-team-logo"><img src="${p.teamLogo}" alt=""/></span>` : ''}<span>${p.teamAbbrev || ''}</span></span>
        </div>`;
      tr.innerHTML = `
        <td>${idx + 1}</td>
        <td>${nameHtml}</td>
        <td>${p.position || ''}</td>
        <td>${p.games ?? ''}</td>
        <td>${p.goals ?? ''}</td>
        <td>${p.assists ?? ''}</td>
        <td><strong>${p.points ?? ''}</strong></td>
        <td>${p.plusMinus ?? ''}</td>
      `;
      tbody.appendChild(tr);
    });
  }

  async function init(table) {
    const count = parseInt(table.getAttribute('data-count') || '10', 10);
    const season = table.getAttribute('data-season') || '';
    try {
      const leaders = await fetchLeaders({ season, count });
      renderTable(table, leaders);
    } catch (err) {
      const tbody = table.querySelector('tbody');
      tbody.innerHTML = `<tr><td colspan="4">Failed to load NHL leaders</td></tr>`;
      // eslint-disable-next-line no-console
      console.error('NHL leaders error', err);
    }
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function() {
    document.querySelectorAll('table[data-nhl-leaders]').forEach(init);
  });
})();


